<template>
  <div class="text">
    <textarea :placeholder="placeholder" v-model="currentValue" @focus="onFocus" @blur="onBlur" ref="textarea"> </textarea>
    <span>{{ currentLen }}/{{ max }}</span>
  </div>
</template>

<script>
export default {
  props: ['value', 'max', 'placeholder', 'isFocus'],
  data() {
    return {
      currentValue: ''
    }
  },
  created() {
    this.currentValue = this.value
  },
  computed: {
    currentLen() {
      return this.value.length
    }
  },
  methods: {
    onFocus() {
      this.$emit('onFocus')
    },
    onBlur() {
      this.$emit('onBlur')
    }
  },
  watch: {
    isFocus() {
      if (this.isFocus) {
        this.$refs.textarea.focus()
      } else {
        this.$refs.textarea.blur()
      }
    },
    value(val) {
      this.currentValue = val
    },
    currentValue(newVal) {
      if (this.max && newVal && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max)
      }
      this.$emit('input', this.currentValue)
      this.$emit('on-change', this.currentValue)
    }
  }
}
</script>

<style scoped lang="less">
.text {
  width: 90%;
  margin-left: 5%;
  position: relative;
  height: 4.93rem;
  textarea {
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    font-size: 0.37rem;
    resize: none;
    background: #f6faf9;
    border: 1px solid #e2f3f1;
    border-radius: 0.08rem;
    padding-left: 0.28rem;
    padding-top: 0.1rem;
    line-height: 0.59rem;
    color: #aaaeb6;
  }
  textarea::-webkit-input-placeholder {
    color: #aaaeb6;
  }
  textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #aaaeb6;
  }
  textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #aaaeb6;
  }
  textarea:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #aaaeb6;
  }
  span {
    position: absolute;
    bottom: 0.35rem;
    right: 0.35rem;
    color: #b3b6bf;
    font-size: 0.35rem;
  }
}
</style>
